import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, map, switchMap, tap } from 'rxjs';
import { CartProduct } from '../models/CartProduct';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ServerResponse } from 'src/app/models/ServerResponse';
import { AddToCartFields } from '../classes/AddToCartFields';
import { Cart } from '../models/Cart';
import { Pagination } from 'src/app/models/Pagination';
import { QueryOptions } from 'src/app/helpers/QueryOptions';
import { UpdateQuantitiyFields } from '../classes/UpdateQuantityFields';
import { AuthService } from '../../auth/services/auth.service';

@Injectable({
	providedIn: 'root'
})
export class CartService {

	private readonly API_CART_URL;
	current = new ReplaySubject<Cart[]>(1);

	constructor(private http:HttpClient,
				private auth:AuthService) {
		this.API_CART_URL = environment.API_URL + "/cart";

		// Esto iría en PreloadAndMulticast pero tendría que llamar a load desde los componentes,
		//	en lugar de manejarlo internamente en el mismo servicio, así que queda acá
		this.auth.oUser.subscribe(u=> {
			if (u)
				this.load().subscribe();
		})
	}

	addToCart(atcf:AddToCartFields) : Observable<void> {
		let route = this.API_CART_URL + "/add";
		return this.http.post<ServerResponse<true>>(route, atcf).pipe(
			switchMap(()=> {
				return this.load();
			})
		);
	}
	removeFromCart(cartProduct:CartProduct) : Observable<ServerResponse<true>> {
		let route = this.API_CART_URL + "/remove/" + cartProduct.product_id +"/"+ cartProduct.variant_id;
		return this.http.get<ServerResponse<true>>(route).pipe(
			tap(()=> {
				this.load().subscribe();
			})
		);
	}
	confirmCartQuantities(uqf_array:UpdateQuantitiyFields[]) : Observable<void> {
		let route = this.API_CART_URL + "/update-quantities";
		return this.http.put<ServerResponse<UpdateQuantitiyFields[]>>(route, {items: uqf_array}).pipe(
			switchMap(()=> {
				return this.load();
			})
		);
	}

	deleteCartAfterPayment(mercado_pago__external_reference:number) : Observable<ServerResponse<true>> {
		let route = this.API_CART_URL +"/by-sale/"+ mercado_pago__external_reference
		return this.http.delete<ServerResponse<true>>(route).pipe(
			tap((sr:ServerResponse<any>)=> {
				this.load().subscribe();
			})
		)
	}


	//#region Manejo local
	load() : Observable<void> {
		let route = this.API_CART_URL + "/list";

		let qo = new QueryOptions();
		qo.withs = ["store"];

		return this.http.post<ServerResponse<Pagination<CartProduct>>>(route, qo).pipe(
			map((sr:ServerResponse<Pagination<CartProduct>>)=> {
				this.parseCarts(sr.response!.data);
			})
		);
	}

	/**
	 * Separa los productos por store_id, para tener los diferentes carritos discriminados
	 */
	private parseCarts(cartProducts:CartProduct[]) {
		let carts : Cart[] = [];
		// Los carritos no vienen identificados por nada. Tengo que separarlos yo

		for (let f = 0; f < cartProducts.length; f++) {
			let store_id = cartProducts[f].product.store_id;
			let cart = carts.find(c=> c.store_id == store_id);
			if (cart) {
				cart.products.push(cartProducts[f]);
			} else {
				let cart = new Cart(store_id, cartProducts[f]);
				carts.push(cart);
			}
		}

		this.current.next(carts);
	}
	//#endregion
}
